import React from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { LinkButton, Breadcrumbs } from 'taboola-ultimate-ui';
import { LinkBreadcrumb } from '../LinkBreadcrumb';
import styles from './systemBreadcrumbs.module.scss';

export const SystemBreadcrumbs = ({ title, steps, shouldRenderEdit, handleEdit, containerClass, editTitle }) => (
    <>
        <div className={containerClass}>
            <Breadcrumbs steps={steps} childProps={{ DisplayComponent: LinkBreadcrumb }} />
            <div className={styles['title-edit-container']}>
                <div className={styles['title']}>{title}</div>
                {shouldRenderEdit ? (
                    <div className={styles['edit-button-container']}>
                        <LinkButton onClick={handleEdit} className={styles['edit-button']}>
                            {editTitle}
                        </LinkButton>
                    </div>
                ) : null}
            </div>
        </div>
    </>
);

SystemBreadcrumbs.propTypes = {
    steps: PropTypes.array,
    shouldRenderEdit: PropTypes.bool,
    handleEdit: PropTypes.func,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default withRouter(SystemBreadcrumbs);
